module.exports = __webpack_public_path__ + "static/media/apple-alt.874008a5.svg";